import {
  Icon,
  Label,
  LabelColor,
  TextEllipsis,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { ServiceCardFooter } from '../service-card-footer';
import { statusColorMap } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import { ServiceCardProps as Props } from './types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useIsPeopleLookalikeEnabled } from '@aibees/elephant/hooks/people';
import { FeatureFlags } from '@aibees/elephant/types';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';

export const ServiceCard = memo(({ className, service }: Props) => {
  const { description, icon, service: name, status, title } = service;

  const { isFeatureEnabled } = useFeatureFlagsContext();
  const isPeopleLookalikeEnabled = useIsPeopleLookalikeEnabled();
  // @maziar todo: we need to take care of handling feature flags for people lookalike search in one place to avoid this logic
  const comingSoon = !(service.feature === FeatureFlags.PEOPLE_LOOKALIKE_SEARCH
    ? isPeopleLookalikeEnabled
    : isFeatureEnabled(service.feature));
  const serviceStatus = comingSoon ? 'Soon!' : status;

  return (
    <Styled.Wrapper
      className={classnames('ServiceCard', className)}
      sx={SX.root}
    >
      <Card variant="outlined" sx={SX.firstCard}>
        <Card variant="outlined" sx={SX.card}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="row" gap={0.5} alignItems="center">
              {icon && (
                <Box sx={SX.iconCard}>
                  <Icon name={icon} size={18} color="primary.500" />
                </Box>
              )}
              <TextEllipsis value={name} sx={SX.name} width="140px" />
            </Stack>

            <Label
              size="xsmall"
              color={statusColorMap[serviceStatus] as LabelColor}
              variant="soft"
            >
              {serviceStatus}
            </Label>
          </Stack>
          <Stack direction="column" gap={1}>
            <Typography variant="body2" fontWeight={600} color="grey.700">
              {title}
            </Typography>
            <Typography variant="body3" fontWeight={400} color="grey.600">
              {description}
            </Typography>
          </Stack>
        </Card>
      </Card>
      <Card variant="outlined" sx={SX.secondCard}>
        <ServiceCardFooter service={service} />
      </Card>
    </Styled.Wrapper>
  );
});

ServiceCard.displayName = 'ServiceCard';
